import {
  IRequisitionData,
  IRequisition,
  IRequisitionLineData,
  IRequisitionLine
} from '../requisition.types';

import { Requisition, RequisitionLine } from '../requisition';
import { IRequisitionPaginatedListData } from '@/services';

export const mockRequisitionsData = (): IRequisitionData[] => [
  {
    id: 1,
    status: {
      value: 0,
      display_name: 'Draft'
    },
    owner: {
      first_name: 'Lamar',
      last_name: 'Falconer',
      email: 'lfalconer@gmail.com'
    },
    amount: 100,
    currency: {
      id: 1,
      code: 'CAD',
      description: 'Canadian Dollar'
    },
    lines: [
      {
        id: 1,
        item: 'Tablet PC',
        description: 'Tablet PC',
        quantity: 2,
        unit_price: 199.99,
        total_price: 399.98,
        uom: 'EA',
        department: {
          id: 1,
          code: '304',
          name: 'IT'
        },
        account: {
          id: 1,
          code: '123456',
          name: 'Cash',
          departments: [
            {
              id: 1,
              code: '304',
              name: 'IT'
            }
          ]
        }
      },
      {
        id: 2,
        item: 'Scanner',
        description: 'Scanner',
        quantity: 1,
        unit_price: 59.0,
        total_price: 59.0,
        uom: 'EA',
        department: {
          id: 1,
          code: '304',
          name: 'IT'
        },
        account: {
          id: 1,
          code: '123456',
          name: 'Cash',
          departments: [
            {
              id: 1,
              code: '304',
              name: 'IT'
            }
          ]
        }
      }
    ],
    created_at: '2021-04-28T17:35:47.304319Z',
    updated_at: '2021-04-28T17:37:43.697225Z'
  },
  {
    id: 2,
    status: {
      value: 0,
      display_name: 'Draft'
    },
    owner: {
      first_name: 'Lamar',
      last_name: 'Falconer',
      email: 'lfalconer@gmail.com'
    },
    amount: 99,
    currency: {
      id: 2,
      code: 'USD',
      description: 'US Dollar'
    },
    lines: [],
    created_at: '2021-04-29T01:02:02.729158Z',
    updated_at: '2021-04-29T01:02:02.729201Z'
  }
];

export const mockRequisitions = (
  data: IRequisitionData[] = mockRequisitionsData()
): IRequisition[] => data.map(item => new Requisition(item));

export const mockRequisitionLinesData = (): IRequisitionLineData[] => [
  {
    id: 1,
    item: 'Tablet PC',
    description: 'Tablet PC',
    quantity: 2,
    unit_price: 199.99,
    total_price: 399.98,
    uom: 'EA',
    department: {
      id: 2,
      code: '201',
      name: 'Engineering'
    },
    account: {
      id: 2,
      code: '654321',
      name: 'Accounts Receivable',
      departments: [
        {
          id: 2,
          code: '201',
          name: 'Engineering'
        }
      ]
    }
  },
  {
    id: 2,
    item: 'Scanner',
    description: 'Scanner',
    quantity: 1,
    unit_price: 59.0,
    total_price: 59.0,
    uom: 'EA',
    department: {
      id: 2,
      code: '201',
      name: 'Engineering'
    },
    account: {
      id: 2,
      code: '654321',
      name: 'Accounts Receivable',
      departments: [
        {
          id: 2,
          code: '201',
          name: 'Engineering'
        }
      ]
    }
  }
];

export const mockRequisitionLines = (
  data: IRequisitionLineData[] = mockRequisitionLinesData()
): IRequisitionLine[] => data.map(item => new RequisitionLine(item));

export const mockRequisitionPaginatedData = (): IRequisitionPaginatedListData => {
  return {
    count: mockRequisitionsData().length,
    next: '',
    previous: '',
    results: mockRequisitionsData()
  };
};
